import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const SearchWrapper = styled.div`
  width: 90%;
  position: absolute;
  bottom: -22px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;

  ${QUERIES.tabletAndUp} {
    width: 400px;
  }
`;
